import React from 'react';
import PropTypes from 'prop-types';
import CONFIG from 'Config/settings';
import IkeaFormField from '@ingka/form-field';
import './InputField.scss';

const FormField = props => (
  <IkeaFormField
    prefix={CONFIG.APP.STYLES_PREFIX}
    valid={props.valid || 'error'}
    {...props}
  />
);

FormField.propTypes = {
  id: PropTypes.string,
  className: PropTypes.string,
  validation: PropTypes.object,
  fieldHelper: PropTypes.object,
  shouldValidate: PropTypes.bool,
  valid: PropTypes.string,
  children: PropTypes.oneOfType([
    PropTypes.node,
    PropTypes.arrayOf(PropTypes.node)
  ])
};

export default FormField;
